import React from 'react';
import { Image, Button } from 'semantic-ui-react';
import Card from '@material-ui/core/Card';
import AppServer from '../../../functions/servername';
import Webserver from '../../../functions/servername';
import $ from "jquery";
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Buttons from '@material-ui/core/Button';
import ReadCookie from '../../../functions/readcookies';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Slide from '@material-ui/core/Slide';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Loading from '../../loading';


const styles = { appBar: { position: 'relative', }, flex: { flex: 1, }, };

function Transition(props) { return <Slide direction="up" {...props} />; }

class ViewAll extends React.Component {

    state = {
        data: [], part: [], related: [], partcodeOption: [], value: 0, originaldata: []
    }

    componentDidMount() {
        this.getPart();
    }

    getPart() {
        let context = this;
        $.ajax({
            type: 'POST', data: { 'id': context.props.id, 'name': context.props.name, 'type': context.props.type, 'model': context.props.model },
            url: AppServer() + 'ui/getparts.php',
            success: function(data) {
                try {
                    let originaldata = JSON.parse(data);
                    data = JSON.parse(data);
                    data = context.removeDuplicates(data);
                    let assemblyNameAndCount = context.assemblyNameAndCount(originaldata);
                    let categoriesNameAndCount = context.categoriesNameAndCount(originaldata);
                    context.setState({ data, originaldata, assemblyNameAndCount, categoriesNameAndCount })
                } catch (error) {
                }
            },
            error: function(err) {
                alert('Try again!!!!')
            }
        });
    }

    categoriesNameAndCount(data) {
        let categoriesNameAndCount = [];
        data.map((c) => {
            if (c.categories != null) {
                let value = 0;
                categoriesNameAndCount.map((v) => {
                    if (v.categories_name == c.categories) {
                        console.log(c.categories);
                        value = 1;
                    }
                })
                if (value == 0) {
                    categoriesNameAndCount.push({ categories_name: c.categories })
                }
            }
        })
        categoriesNameAndCount.map((c) => {
            let count = 0
            data.map((v) => {
                if (c.categories_name == v.categories) {
                    count++;
                }
            })
            c.count = count;
        })
        return categoriesNameAndCount;
    }

    assemblyNameAndCount(data) {
        let assemblyNameAndCount = [];
        data.map((c) => {
            let value = 0;
            if (c.sets) {
                assemblyNameAndCount.map((v) => {
                    if (v.assembly_name == c.sets) {
                        value = 1;
                    }
                })
                if (value == 0) {
                    assemblyNameAndCount.push({ assembly_name: c.sets })
                }
            }
        })
        assemblyNameAndCount.map((c) => {
            let count = 0
            data.map((v) => {
                if (c.assembly_name == v.sets) {
                    count++;
                }
            })
            c.count = count;
        })
        return assemblyNameAndCount;
    }

    removeDuplicates(originalArray) {
        var newArray = [];
        originalArray = originalArray.slice().reverse();
        var lookupObject  = {};
        for(var i in originalArray) {
           lookupObject[originalArray[i]['partno']] = originalArray[i];
        }
        for(i in lookupObject) {
            newArray.push(lookupObject[i]);
        }
        return newArray;
    }

    addItem(item) {
        let customerDualScreenorderList = localStorage.getItem("customerDualScreenorderList");
        if (!customerDualScreenorderList) {
            customerDualScreenorderList = "[]";
        }
        try {
            customerDualScreenorderList = JSON.parse(customerDualScreenorderList);
            if (!customerDualScreenorderList) {
                customerDualScreenorderList = [];
            }
            let refId = 0;
            let value = 0;
            customerDualScreenorderList.map((v) => {
                if (v.partno == item.partno) {
                    value = 1;
                    v.qty = v.qty + 1;
                    v.quantity = v.quantity + 1;
                }
                else { 
                    refId = v.refId;
                }
            })
            refId = refId + 1;
            if (value == 0) {
                customerDualScreenorderList.push({ 
                    'partno': item.partno, 'discountrs': 0,
                    'spare_name': item.title, 'partname': item.title, 'discountper': 0, 'point': 0, 'ava_stocks': 0, 
                    'qty': 1, 'refId': refId, 'brand': 1, 'remarks': 'remarks',
                    'tax': item.tax, 'discount': 0, 'quantity': 1, checked: false,
                    'billtype': 'Invoice', 'mrp': item.mrp, 'uprice': item.mrp, 
                })
            }
            customerDualScreenorderList = JSON.stringify(customerDualScreenorderList);
            localStorage.setItem("customerDualScreenorderList", customerDualScreenorderList);
            this.props.refreshData();
            this.setState({ customerDualScreenorderList })
        } catch (error) {
        }
    }

    getSpareDetails(partno, item) {
        this.props.detailsSparesPage(partno, item);
    }

    changeStatus() {
        this.setState({ status: 0 })
    }

    render() {
        const { fullScreen } = this.props;
        const { classes } = this.props;
        let { value, originaldata, status, name } = this.state;
        return (
            <div class="mobileview">
                <Loading load={this.state.load} message={this.state.message} />
                { this.props.type == 'Section' ?
                    (
                        <AppBar position="static">
                            <Tabs value={this.state.value} indicatorColor="primary"
                                textColor="primary"  variant="fullWidth" >
                                <Tab label="ALL" style={{color: value == 0 ? 'white': 'black'}} onClick={ () => { this.setState({ value: 0 }) }} />
                                <Tab label="ASSEMBLY" style={{color: value == 1 ? 'white': 'black'}} onClick={ () => { this.setState({ value: 1 }) }} />
                                <Tab label="CATEGORIES" style={{color: value == 2 ? 'white': 'black'}} onClick={ () => { this.setState({ value: 2 }) }} />
                            </Tabs>
                        </AppBar>
                    ):''
                }
                { value == 0 ?
                    (
                        <Grid container spacing={0}>
                            { 
                                this.state.data.map((c) => {
                                    return (
                                        <Grid item xs={12}>
                                            <Paper>
                                                <div style={{display: 'flex', width: '100%'}}>
                                                    <div style={{width: '20%', cursor: 'pointer'}} onClick={this.getSpareDetails.bind(this, c.partno, c)}>
                                                        <Image  src={"https://s3.ap-south-1.amazonaws.com/vaigaiclaas.com/feature/"+c.partno+".jpg"} style={{width: '100px', height: '100px', borderRadius: '5px', margin: '3px'}} />
                                                    </div>
                                                    <div style={{padding: '5px', width: '65%', cursor: 'pointer'}} onClick={this.getSpareDetails.bind(this, c.partno, c)}>
                                                        <b style={{fontSize: '16px'}}>{c.title+'('+c.partno+')'}</b>
                                                        <div>{c.tamil_name}</div>
                                                        <div>{c.local_name}</div>
                                                        <div>{c.description}</div>
                                                    </div>
                                                    <div style={{width: '15%'}}>
                                                        <Button style={{backgroundColor: '#abb119', color: 'white', marginTop: '4px'}} 
                                                            onClick={this.addItem.bind(this, c)}>ADD</Button>
                                                    </div>
                                                </div>
                                            </Paper>
                                        </Grid>
                                    )
                                })
                            }
                        </Grid>
                    ):
                    (
                        <div>
                            { value == 1 ?
                                (
                                    <div class="mobileview">
                                        <Grid container spacing={0}>
                                            {
                                                this.state.assemblyNameAndCount.map((c) => {
                                                    return (
                                                        <Grid item xs={6} onClick={ () => { this.props.screennav(1, c.assembly_name, originaldata); this.setState({  }) }} style={{cursor: 'pointer'}}>
                                                            <Paper style={{width: '100%', display: 'flex', height: 100, margin: '0.5%'}}>
                                                                <div style={{backgroundColor: '#A9A9A9', width: 150}}>
                                                                    <center style={{marginTop: '25%'}}><h3 style={{color: 'white'}}>{c.count}</h3></center>
                                                                </div>
                                                                <div style={{marginTop: 'auto', marginBottom: 'auto', marginLeft: '4%'}}><h3>{c.assembly_name}</h3></div>
                                                            </Paper>
                                                        </Grid>
                                                    )
                                                })
                                            }
                                        </Grid>
                                    </div>
                                ):
                                (
                                    <div class="mobileview">
                                        <Grid container spacing={0}>
                                            {
                                                this.state.categoriesNameAndCount.map((c) => {
                                                    return (
                                                        <Grid item xs={6} onClick={ () => { this.props.screennav(2, c.categories_name, originaldata); }} style={{cursor: 'pointer'}}>
                                                            <Paper style={{width: '100%', display: 'flex', height: 100, margin: '0.5%'}}>
                                                                <div style={{backgroundColor: '#A9A9A9', width: 150}}>
                                                                    <center style={{marginTop: '25%'}}><h3 style={{color: 'white'}}>{c.count}</h3></center>
                                                                </div>
                                                                <div style={{marginTop: 'auto', marginBottom: 'auto', marginLeft: '4%'}}><h3>{c.categories_name}</h3></div>
                                                            </Paper>
                                                        </Grid>
                                                    )
                                                })
                                            }
                                        </Grid>
                                    </div>
                                )
                            }
                        </div>
                    )
                }
                

                { this.state.item ? 
                    (
                        <Dialog fullScreen
                            open={this.state.openSparesDetailDialog} onClose={ () => { this.setState({ openSparesDetailDialog: false }) }}
                            TransitionComponent={Transition}>
                            <AppBar className={classes.appBar}>
                                <Toolbar>
                                <IconButton color="inherit" onClick={ () => { this.setState({ openSparesDetailDialog: false }) }} aria-label="Close"> <CloseIcon />
                                </IconButton>
                                <Typography variant="h6" color="inherit" className={classes.flex}>{this.state.item.title}</Typography>
                                </Toolbar>
                            </AppBar>
                                <div style={{margin: '1%'}}>

                                
                                <Grid container spacing={1}>
                                    <Grid item xs={4}>
                                        <Image refs="scrolldiv" src={"https://s3.ap-south-1.amazonaws.com/vaigaiclaas.com/feature/"+this.state.item.partno+".jpg"} 
                                        style={{width: '100%', height: 400}} />
                                    </Grid>
                                    <Grid item xs={8}>
                                        <div style={{margin: '2%'}}>
                                            <h4>Highlights</h4>
                                            <div style={{borderColor: 'black', borderStyle: 'solid', borderWidth: '1px', padding: '1%', borderRadius: '3px'}}>
                                                <b>Description</b>
                                                <div>{this.state.item.description}</div>
                                                <br/>
                                                <b>Feature And Details</b>
                                                <div>
                                                    <div style={{display: 'flex', width: '100%'}}>
                                                        <div style={{width: '30%'}}><b>Tamil Name</b></div>
                                                        <div style={{width: '70%'}}>{this.state.item.tamil_name}</div>
                                                    </div>

                                                    <div style={{display: 'flex', width: '100%'}}>
                                                        <div style={{width: '30%'}}><b>Local Name</b></div>
                                                        <div style={{width: '70%'}}>{this.state.item.local_name}</div>
                                                    </div>

                                                    <div style={{display: 'flex', width: '100%'}}>
                                                        <div style={{width: '30%'}}><b>Part Number</b></div>
                                                        <div style={{width: '70%'}}>{this.state.item.partno}</div>
                                                    </div>

                                                    <div style={{display: 'flex', width: '100%'}}>
                                                        <div style={{width: '30%'}}><b>Machine Support</b></div>
                                                        <div style={{width: '70%'}}>{this.state.part.from_serialno+' - '+this.state.part.to_serialno}</div>
                                                    </div>

                                                    <div style={{display: 'flex', width: '100%'}}>
                                                        <div style={{width: '30%'}}><b>Weight of the product</b></div>
                                                        <div style={{width: '70%'}}>{this.state.part.weight+' Kg(s)'}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <Buttons  onClick={this.addItem.bind(this, this.state.item)} 
                                                style={{marginTop: '1%', marginBottom: '1%'}} color='primary' 
                                                variant='outlined' fullWidth>ADD</Buttons>
                                        </div>
                                        
                                    </Grid>
                                </Grid>

                                <h4>Related Products</h4>
                                <Grid container spacing={10}>
                                    {
                                        this.state.related.map((c) => {
                                            return (
                                                <Grid item xs={2}>
                                                    <Paper>
                                                        <div style={{cursor: 'pointer'}} onClick={this.getSpareDetails.bind(this, c.partno, c)}>
                                                            <Image src={"https://s3.ap-south-1.amazonaws.com/vaigaiclaas.com/feature/"+c.partno+".jpg"} 
                                                            style={{width: '97%', height: '200px', borderRadius: '5px', margin: '3px'}} />
                                                        </div>
                                                        <div style={{padding: '5px', cursor: 'pointer'}} onClick={this.getSpareDetails.bind(this, c.partno, c)}>
                                                            <b style={{fontSize: '13px'}}>{c.title}</b><br/>
                                                            <b style={{fontSize: '13px'}}>{c.partno}</b>
                                                        </div>
                                                        <div>
                                                            <Buttons onClick={this.addItem.bind(this, c)} 
                                                                style={{margin: '5%', width: '90%'}} 
                                                                color='primary' variant='outlined'>
                                                                ADD
                                                            </Buttons>
                                                        </div>
                                                    </Paper>
                                                </Grid>
                                            )
                                            
                                        })
                                    }
                                </Grid>
                                </div>
                        </Dialog>
                    ):''
                }
                
            </div>
        );
    }
}


ViewAll.propTypes = { classes: PropTypes.object.isRequired, };

export default withStyles(styles)(ViewAll);